import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';

type ODAControlState = {
  isUpsellModalOpen: boolean;
};

export type ODAControlAttrs = {
  description: string;
  'is-waiting-for-schedule-analysis': boolean;
  'show-upsell': boolean;
  'upsell-description': string;
};

export class ODAControl extends Component<ODAControlState, ODAControlAttrs> {
  static get attrsSchema(): AttrsSchema<ODAControlAttrs> {
    return {
      description: `string`,
      'is-waiting-for-schedule-analysis': `boolean`,
      'show-upsell': `boolean`,
      'upsell-description': `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleClickAnalyze: () => this.dispatchEvent(new CustomEvent(`clickAnalyze`)),
        handleClickUpsell: () => this.update({isUpsellModalOpen: true}),
        handleChangeUpsellModal: (ev) => {
          if (ev.detail.state === `closed`) {
            this.update({isUpsellModalOpen: false});
          }
        },
      },
      defaultState: {
        isUpsellModalOpen: false,
      },
    };
  }
}

export const ODAControlEl = defineAndMakeJsxFactory(`mp-oda-control`, ODAControl);
